import $ from "jquery";
const PATH = "api:///v2/properties";
const getProperties = () => $.ajax({
    method: "GET",
    url: `${PATH}`,
});
const createProperty = (request) => $.ajax({
    method: "POST",
    url: `${PATH}`,
    contentType: "application/json",
    data: JSON.stringify(request),
});
const updateProperty = (request) => $.ajax({
    method: "PUT",
    url: `${PATH}/${request.name}`,
    contentType: "application/json",
    data: JSON.stringify({ value: request.value }),
});
export default {
    getProperties,
    createProperty,
    updateProperty,
};
